import { render, staticRenderFns } from "./FloatingAskAiDropdown.vue?vue&type=template&id=4b0582ff"
import script from "./FloatingAskAiDropdown.vue?vue&type=script&lang=js"
export * from "./FloatingAskAiDropdown.vue?vue&type=script&lang=js"
import style0 from "./FloatingAskAiDropdown.vue?vue&type=style&index=0&id=4b0582ff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports